import { NO_IMAGE_AVAILABLE } from 'constants';
import _get from 'lodash/get';

const getAlerternateImages = (source, destination, userBrand) => {
  Object.keys(source.media.alternate).map((key) => {
    const imageUrl = _get(source.media.alternate[key], 'medium.url') || NO_IMAGE_AVAILABLE[userBrand];
    return destination.push(/^\/{1}[a-zA-Z]/.test(imageUrl) ? `//neimanmarcus.com${imageUrl}` : imageUrl);
  });
};

export const getProductImage = (product = {}, skuInfo = {}, userBrand = '') => {
  const isDynamic = product.productFlags?.dynamicImageSkuColor;
  const productImg = _get(product, 'media.main.medium.url');
  const skuImg = _get(skuInfo, 'media.main.medium.url') || _get(skuInfo, 'media.main.thumbnail.url');
  const productImages = productImg ? [productImg] : [];
  const skuImages = skuImg ? [skuImg] : [productImg];
  const noImageAvailable = NO_IMAGE_AVAILABLE[userBrand];

  if (_get(product, 'media.alternate')) {
    getAlerternateImages(product, productImages, userBrand);
  }

  if (_get(skuInfo, 'media.alternate')) {
    getAlerternateImages(skuInfo, skuImages, userBrand);
  }

  const images = isDynamic ? skuImages || productImages : productImages || skuImages;

  if (!images.length) {
    images.push(noImageAvailable);
  }

  return images;
};

export const getProductVideo = (product = {}) => {
  const video = _get(product, 'media.video.video.url');
  if (video) {
    const thumbnail = _get(product, 'media.video.thumbnail.url');
    return {
      url: video,
      thumbnail,
    };
  }
  return null;
};

export const getCurrentCategoryFromTaxonomy = (id, array = []) => {
  const category = array.find((cat) => cat?.id === id);
  if (category) return category;
  const children = array.reduce((acc, cur) => acc.concat(cur?.children || []), []);
  return !children?.length ? children : getCurrentCategoryFromTaxonomy(id, children);
};

/**
 * Function to retrive object from URL search params
 * @param {String} [searchParam] "?text=search"
 * @returns {{[key: string]: string}} { text: "search" }
 */
export const getQueryParams = (searchParam) => {
  const queryParams = {};
  const newParams = new URLSearchParams(searchParam);

  newParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams;
};

export const calculateDiscountPrice = (retailPrice, discount) => {
  let discountPrice;
  if (!discount) {
    discountPrice = retailPrice;
  } else {
    discountPrice = retailPrice * ((100 - discount) * 0.01);
  }

  return discountPrice.toFixed(2);
};

export const cleanParams = (params) => {
  const newParams = {};
  Object.keys(params).forEach((key) => {
    newParams[key] = params[key] !== '' ? params[key] : null;
  });

  return newParams;
};

export const adjustSearchParams = (params) => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = params[key];
    }
    if (key === 'text') {
      acc.search = value;
    }
    if (typeof value === 'string' && value !== '') {
      if (key !== 'sortBy' && key !== 'sortDirection') {
        acc[key] = value.split(',');
      }
      if (key === 'minPrice' || key === 'maxPrice') {
        acc[key] = parseInt(value, 10);
      }
      if (value === 'PRICE') {
        acc[key] = 'retailPrice';
      }
      if (value === 'CREATED') {
        acc[key] = 'sellableDate';
      }
    }
    if (key === 'categoryId') {
      acc.categoryId = value;
    }
    delete acc.text;
    return acc;
  }, {});
};
export const itemsCountTextForPLP = (totalCount, maxThreshold = 10000) =>
  totalCount > maxThreshold ? `${maxThreshold}+ items` : `${totalCount} items`;

export const mapSkuStoresToStores = (skuStores = [], webProductSku) => {
  const { storeInventories } = skuStores.find((skuStore) => skuStore.skuId === webProductSku) || {};
  const stores = storeInventories?.map(({ storeId, bopsQty, qty }) => ({
    storeId,
    bopsAvailQty: bopsQty,
    totalAvailQty: qty,
  }));

  return stores;
};

export const extendSkuInfoWithProductDetails = (productDetails = {}, skuInfo = {}) => {
  const { price, skuStores } = productDetails;
  const {
    id: webProductSku,
    productId: webProductId,
    dropShip: dropShipFlag,
    isRestricted = false,
    stockLevel = 0,
  } = skuInfo;

  const stores = mapSkuStoresToStores(skuStores, webProductSku);
  const { paddedInventory = 0, storeInventories = [] } =
    skuStores?.find((skuStore) => skuStore.skuId === webProductSku) || {};

  return {
    ...skuInfo,
    dropShip: Boolean(dropShipFlag === 'Y'),
    paddedInventory,
    price: { retailPrice: price.retailPrice },
    restrictedItem: isRestricted,
    skuStores,
    skuInventory: storeInventories,
    stockLevel,
    store: stores || [],
    webProductId,
    webProductSku,
  };
};
